import { createContext, useContext, useState } from 'react';

const DealerCartContext = createContext(null);

export function DealerCartProvider({ children }) {
  const [cartCount, setCartCount] = useState(0);
  const [cartOpen, setCartOpen] = useState(false);

  return (
    <DealerCartContext.Provider value={{ cartCount, setCartCount, cartOpen, setCartOpen }}>
      {children}
    </DealerCartContext.Provider>
  );
}

export function useDealerCart() {
  const ctx = useContext(DealerCartContext);
  if (!ctx) throw new Error('useDealerCart must be used inside DealerCartProvider');
  return ctx;
}
